import React from 'react'
import { Upload, Form, Icon, Select, Button } from 'antd';

const { Option } = Select;

const fileDummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

export default (props) => {
  return(
    <div className="form-group">
      <div className="form-group-details">
        <h4>Paper Consent Process</h4>
        <h5>Site ID: <b>{props.siteID}</b></h5>
        <h5>User ID: <b>{props.userID}</b></h5>
        <h5>Subject ID: <b>{props.subjectID}</b></h5>
        <h5>Consent Type: <b>{props.consentPersonType}</b></h5>
        <h5>Consent Method: <b>{props.consentMethodType}</b></h5>
      </div>

      <Form.Item>
        {props.form.getFieldDecorator('consentFile', {
          initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [],
          valuePropName: 'fileList',
          getValueFromEvent: props.normFile,
          rules: [{
            required: true,
            message: 'Please upload the consent file!'
          }],
        })(
          <Upload
            id="consentFile"
            name="consentFile"
            customRequest={fileDummyRequest}
            accept=".pdf"
            allowClear
            size="large"
            >
            <Button>
              <Icon type="upload" /> Upload Consent Form
            </Button>
          </Upload>
        )}
      </Form.Item>

      <Form.Item>
        <label>
          <div className='form-label'>Do you consent to the terms described above? If no, please click on the Back button!</div>
          {props.form.getFieldDecorator('consent_provided', {
            initialValue: props.consent_provided,
            rules: [{
              required: true,
              message: 'Do you consent to the terms described above?'
            }],
          })(
            <Select>
              <Option value="yes">Yes</Option>
              <Option value="">No</Option>
            </Select>
          )}
        </label>
      </Form.Item>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWinnipeg/Step3b.js